import i18n from '../../../i18n';

export const deviceCountersReportFields = [
    "modelCode",
    "serialNumber",
    "inventoryNumber",
    "ip",
    "location",
    "bwStart",
    "bwEnd",
    "bwCopyStart",
    "bwCopyEnd",
    "colorStart",
    "colorEnd",
    "colorCopyStart",
    "colorCopyEnd",
    "daysCount",
    "bwDiff",
    "bwCopyDiff",
    "colorDiff",
    "colorCopyDiff"
];

export const deviceCountersReportConfig = {
    code : 'DEVICE_COUNTERS',
    gridStateKey: 'gridReportDeviceCounters',
    filter: {
        getter: 'deviceCountersFilter',
        mutation: 'setDeviceCountersFilter'
    },
    columns: [{
        id: 1,
        dataField : 'modelCode',
        caption : i18n.t('report.titleReports.deviceCounters.modelCode'),
        dataType : 'string',
        sortOrder: 10
    }, {
        id: 2,
        dataField : 'serialNumber',
        caption : i18n.t('report.titleReports.deviceCounters.serialNumber'),
        dataType : 'string',
        sortOrder: 20
    }, {
        id: 3,
        dataField : 'inventoryNumber',
        caption : i18n.t('report.titleReports.deviceCounters.inventoryNumber'),
        dataType : 'string',
        sortOrder: 30
    }, {
        id: 4,
        dataField : 'ip',
        caption : i18n.t('report.titleReports.deviceCounters.ip'),
        dataType : 'string',
        sortOrder: 40
    }, {
        id: 5,
        dataField : 'location',
        caption : i18n.t('report.titleReports.deviceCounters.location'),
        dataType : 'string',
        sortOrder: 50
      }, {
        id: 6,
        dataField : 'bwStart',
        caption : i18n.t('report.titleReports.deviceCounters.bwStart'),
        dataType : 'number',
        sortOrder: 60
      }, {
        id: 7,
        dataField : 'bwEnd',
        caption : i18n.t('report.titleReports.deviceCounters.bwEnd'),
        dataType : 'number',
        sortOrder: 70
      }, {
        id: 8,
        dataField : 'bwCopyStart',
        caption : i18n.t('report.titleReports.deviceCounters.bwCopyStart'),
        dataType : 'number',
        sortOrder: 80
      }, {
        id: 9,
        dataField : 'bwCopyEnd',
        caption : i18n.t('report.titleReports.deviceCounters.bwCopyEnd'),
        dataType : 'number',
        sortOrder: 90
      }, {
        id: 10,
        dataField : 'colorStart',
        caption : i18n.t('report.titleReports.deviceCounters.colorStart'),
        dataType : 'number',
        sortOrder: 100
      }, {
        id: 11,
        dataField : 'colorEnd',
        caption : i18n.t('report.titleReports.deviceCounters.colorEnd'),
        dataType : 'number',
        sortOrder: 110
      }, {
        id: 12,
        dataField : 'colorCopyStart',
        caption : i18n.t('report.titleReports.deviceCounters.colorCopyStart'),
        dataType : 'number',
        sortOrder: 120
      }, {
        id: 13,
        dataField : 'colorCopyEnd',
        caption : i18n.t('report.titleReports.deviceCounters.colorCopyEnd'),
        dataType : 'number',
        sortOrder: 130
      }, {
        id: 14,
        dataField : 'daysCount',
        caption : i18n.t('report.titleReports.deviceCounters.daysCount'),
        dataType : 'number',
        sortOrder: 140
      }, {
        id: 15,
        dataField : 'bwDiff',
        caption : i18n.t('report.titleReports.deviceCounters.bwDiff'),
        dataType : 'number',
        sortOrder: 150
      }, {
        id: 16,
        dataField : 'bwCopyDiff',
        caption : i18n.t('report.titleReports.deviceCounters.bwCopyDiff'),
        dataType : 'number',
        sortOrder: 160
      }, {
        id: 17,
        dataField : 'colorDiff',
        caption : i18n.t('report.titleReports.deviceCounters.colorDiff'),
        dataType : 'number',
        sortOrder: 170
      }, {
        id: 18,
        dataField : 'colorCopyDiff',
        caption : i18n.t('report.titleReports.deviceCounters.colorCopyDiff'),
        dataType : 'number',
        sortOrder: 180
      }]
}
